import React, { useState, useEffect } from 'react';
import UserStatus from './UserStatus';
import MusicPlayer from './MusicPlayer';
import TypeWriter from './TypeWriter';
import { FaDiscord, FaTelegram, FaGithub, FaSteam, FaInstagram, FaCheck } from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';
import { BsGlobe } from 'react-icons/bs';
import ActivityCarousel from './ActivityCarousel';
import ProfessionalBadges from './ProfessionalBadges';

interface Activity {
  name: string;
  type: string;
  details?: string;
  state?: string;
  assets?: {
    large_image?: string;
    large_text?: string;
  };
  timestamps?: {
    start?: number;
    end?: number;
  };
}

interface DiscordStatus {
  status: string;
  activities: Activity[];
  avatar: string;
  username: string;
  discordId: string;
  customStatus?: {
    state?: string;
    emoji?: {
      name: string;
      id: string;
      animated: boolean;
    };
  };
}

interface ProfileCardProps {
  autoPlayMusic: boolean;
}

const ProfileCard: React.FC<ProfileCardProps> = ({ autoPlayMusic }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [discordStatus, setDiscordStatus] = useState<DiscordStatus | null>(null);
  const [customStatus, setCustomStatus] = useState<string | undefined>(undefined);

  useEffect(() => {
    setIsVisible(true);
    fetchDiscordStatus();
  }, []);

  const fetchDiscordStatus = async () => {
      try {
        const response = await fetch('http://localhost:3001/api/discord-status');
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data: DiscordStatus = await response.json();
        setDiscordStatus(data);

        // Extract custom status
        setCustomStatus(data.customStatus?.state);

        console.log('Discord data:', data);
        console.log('Custom status:', data.customStatus?.state);
      } catch (error) {
        console.error('Error fetching Discord status:', error);
        setDiscordStatus(null);
      }
    };

  const songs = [
    {
      id: 1,
      title: "plateau",
      artist: "IVOXYGEN",
      audioSrc: "/assets/music/plateau.mp3",
      imageSrc: "./assets/music/plateau-cover.jpg"
    },
    {
      id: 2,
      title: "Hate Me!",
      artist: "MASN",
      audioSrc: "/assets/music/hateme.m4a",
      imageSrc: "/assets/music/hateme-cover.jpg"
    },
    {
      id: 3,
      title: "Rackz got më",
      artist: "Yeat",
      audioSrc: "/assets/music/rackz.mp3",
      imageSrc: "/assets/music/rackz-cover.jpg"
    },
    {
      id: 4,
      title: "NEW DAWN",
      artist: "CYREX",
      audioSrc: "/assets/music/newdawn.mp3",
      imageSrc: "/assets/music/newdawn-cover.jpg"
    },
    {
      id: 5,
      title: "Sorry Bout That",
      artist: "Yeat",
      audioSrc: "/assets/music/sorry.mp3",
      imageSrc: "/assets/music/sorry-cover.jpg"
    },
  ];

  return (
    <div className="flex justify-center items-center min-h-screen p-4">
      <div className={`transition-opacity duration-500 ${isVisible ? 'opacity-100' : 'opacity-0'} max-w-2xl w-full`}>
        <div className="relative" style={{
          borderRadius: '0.4rem',
          // backdropFilter: 'blur(10px)',
          backgroundColor: 'rgba(33, 33, 33, 0.95)',
          boxShadow: 'rgba(255, 255, 255, 0.9) 0px 0px 30px 0.5px',
          transform: 'translateY(0px)',
          opacity: 1,
        }}>
          <img
            src="/assets/images/banner.gif"
            alt="Profile Banner"
            className="object-cover w-full h-32"
            style={{
              borderColor: 'rgb(255, 255, 255)',
              borderWidth: '2px',
              borderTopLeftRadius: '0.4rem',
              borderTopRightRadius: '0.4rem',
              backgroundColor: 'rgba(33, 33, 33, 0.9)',
            }}
          />
          <div className="main-box p-4">
            <UserInfo />
            <ProfessionalBadges />
            <SocialLinks />
             {discordStatus && (
              <div className="mt-4">
                <div className="p-4 rounded-xl" style={{
                  borderColor: 'rgb(255, 255, 255)',
                  borderWidth: '2px',
                  backgroundColor: 'rgba(66, 66, 66, 0.9)',
                }}>
                  <UserStatus
                    status={discordStatus.status}
                    avatar={discordStatus.avatar}
                    username={discordStatus.username}
                    customStatus={customStatus}
                    discordId={discordStatus.discordId}
                  />
                  <div className="w-full h-0.5 my-3 bg-white opacity-100" />
                  <ActivityCarousel activities={discordStatus.activities.filter(activity => activity.type !== 'CUSTOM')} />
                </div>
              </div>
            )}
            <div className="mt-4">
              <MusicPlayer songs={songs} autoPlay={autoPlayMusic} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const UserInfo: React.FC = () => {
  return (
    <div className="flex flex-col">
      <div className="my-[-3.2rem] -translate-y-[3.2rem] flex items-center justify-center">
        <img
          src="/assets/images/avatar.gif"
          alt="User Avatar"
          className="h-[120px] w-[120px] rounded-full relative"
          style={{
            borderColor: 'rgb(255, 255, 255)',
            borderWidth: '2px',
          }}
        />
      </div>
      <div className="flex flex-col">
        <div className="flex sm:flex-row flex-wrap flex-col justify-center gap-x-2 gap-y-1 mx-auto items-center mt-2 mb-1">
          <h1 className="font-semibold text-[32px] break-all text-center" style={{
            color: 'rgb(255, 255, 255)',
            backgroundImage: 'url("/assets/images/sparkle_effect.gif")',
            lineHeight: '32px',
          }}>
            mimiseksimi
          </h1>
        </div>
        <TypeWriter
            text="Hi! I'm a developer specializing in Python, PHP, and C/C++. Additionally, I work with ESP32 for IoT projects. Fluent in English, German, Russian, and Ukrainian."
            typingSpeed={30}
            erasingSpeed={20}
            delayBeforeErasing={5000}
          />
        </div>
    </div>
  );
};

const SocialLinks: React.FC = () => {
  const [notification, setNotification] = useState<string | null>(null);
  const [copiedIcon, setCopiedIcon] = useState<string | null>(null);

  const showNotification = (message: string) => {
    setNotification(message);
    setTimeout(() => setNotification(null), 3000);
  };

  const copyToClipboard = (text: string, name: string, icon: string) => {
    navigator.clipboard.writeText(text).then(() => {
      showNotification(`${name} copied to clipboard!`);
      setCopiedIcon(icon);
      setTimeout(() => setCopiedIcon(null), 3000);
    }).catch(err => {
      console.error('Failed to copy text: ', err);
      showNotification('Failed to copy. Please try again.');
    });
  };

  return (
    <div className="flex flex-col items-center relative">
      <div className="flex flex-wrap justify-center gap-4 mt-6">
        <SocialLink
          Icon={FaDiscord}
          href="#"
          tooltip="Copy Discord Username"
          onClick={() => copyToClipboard('kot16', 'Discord username', 'discord')}
          isCopied={copiedIcon === 'discord'}
        />
        <SocialLink Icon={FaTelegram} href="https://t.me/mrblackcatdev" tooltip="Open Telegram" />
        <SocialLink Icon={FaGithub} href="https://github.com/13MrBlackCat13" tooltip="Open GitHub" />
        <SocialLink Icon={FaSteam} href="https://steamcommunity.com/id/mrblackcatdev" tooltip="Open Steam" />
        <SocialLink
          Icon={MdEmail}
          href="#"
          tooltip="Copy Email Address"
          onClick={() => copyToClipboard('contact@mrblackcat.dev', 'Email address', 'email')}
          isCopied={copiedIcon === 'email'}
        />
        <SocialLink Icon={BsGlobe} href="https://mrblackcat.dev/" tooltip="Visit Website" />
        <SocialLink Icon={FaInstagram} href="https://www.instagram.com/m1blackcat/" tooltip="Open Instagram" />
      </div>
      {notification && (
        <div className="fixed bottom-4 right-4 p-3 bg-gray-800 text-white rounded-lg shadow-lg transition-all duration-300 ease-in-out transform translate-y-0 opacity-100">
          {notification}
        </div>
      )}
    </div>
  );
};

interface SocialLinkProps {
  Icon: React.ElementType;
  href: string;
  tooltip: string;
  onClick?: () => void;
  isCopied?: boolean;
}

const SocialLink: React.FC<SocialLinkProps> = ({ Icon, href, tooltip, onClick, isCopied }) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    if (onClick) {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <div className="relative group">
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={`p-3 flex items-center justify-center rounded-full transition-all duration-300 ${
          isCopied ? 'bg-green-500' : 'bg-gray-800 hover:bg-gray-700'
        }`}
        onClick={handleClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {isCopied ? (
          <FaCheck className="h-6 w-6 text-white" />
        ) : (
          <Icon className={`h-6 w-6 text-white transition-transform duration-300 ${isHovered ? 'transform scale-110' : ''}`} />
        )}
      </a>
      <div className={`absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-gray-800 text-white text-xs rounded transition-opacity duration-300 ${
        isHovered ? 'opacity-100' : 'opacity-0 pointer-events-none'
      }`}>
        {tooltip}
      </div>
    </div>
  );
};

export default ProfileCard;
